/* eslint-disable */
import { subDays } from 'date-fns';
// @ts-ignore
import ls from 'local-storage';
import _ from 'underscore';

const PRICE_JUMP_DATA_KEY = 'priceJumpData';

interface HotelPageToursData {
    id: string;
    price: number;
    timeStamp: string;
    isItPriceProvider: boolean;
}

interface PriceJumpData {
    [uuid: string]: HotelPageToursData
}

const isDateActual = (dateKey: string) => {
    const keyDate = new Date(dateKey);
    return keyDate >= subDays(new Date(), 7);
};

const updateToursData = (hotelPageToursData: HotelPageToursData[]): void => {
    if (!hotelPageToursData || hotelPageToursData.length === 0) {
        return;
    }

    const existingData: PriceJumpData = ls.get(PRICE_JUMP_DATA_KEY) || {};
    const existingCurrentDate = _.pick(existingData, (value) => isDateActual(value.timeStamp));

    const groupedData = _.indexBy(hotelPageToursData, 'id');

    const updatedCurrentDateData = {
        ...existingCurrentDate,
        ...groupedData,
    };

    ls.set(PRICE_JUMP_DATA_KEY, updatedCurrentDateData);
};

const getHotelPageToursData = (priceProviderUuid: string): HotelPageToursData[] | null => {
    const priceJumpData = ls.get(PRICE_JUMP_DATA_KEY);
    const hotelPageToursData = priceJumpData
        ? priceJumpData[priceProviderUuid]
        : null;

    if (!hotelPageToursData) {
        return null;
    }

    return hotelPageToursData;
};

export {
    updateToursData,
    getHotelPageToursData,
};